import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import queryString from 'query-string';
import { confirmSignUpAction, resendConfirmationCodeAction } from 'Store/modules/auth/actions';
import { routeStateSelector, searchSelector } from 'Store/modules/router/selectors';
import View from './view';

const AccountValidation = (): JSX.Element => {
  const email = useSelector(routeStateSelector);
  const search = useSelector(searchSelector);
  const dispatch = useDispatch();

  const params = queryString.parse(search);

  useEffect(() => {
    const { token, ref } = params;
    if (token) {
      dispatch(confirmSignUpAction({ token, ref }));
    }
  }, []);

  const resendVerificationCode = (): void => {
    dispatch(resendConfirmationCodeAction(email));
  };

  return <View onSendCode={resendVerificationCode} />;
};

export default AccountValidation;
